module.exports = __webpack_public_path__ + "img/chatbubble1-img.4f56ef3d.svg";